import { ROOM_TYPE } from "../constants";

export function matchChannels(channelsObj, fn) {
  return Object.keys(channelsObj).reduce((accum, channelId) => {
    const channel = channelsObj[channelId];
    if (fn(channel)) {
      accum.push(channel);
    }
    return accum;
  }, []);
}

export function sortByName({ name: a }, { name: b }) {
  return a > b ? 1 : -1;
}

export function sortByLastMessageAt(
  { lastMessage: { createdAt: a } },
  { lastMessage: { createdAt: b } }
) {
  return a < b ? 1 : -1;
}

export function createRoomsFilterByUser(user) {
  const { community, tags } = user;
  const filter = {
    type: ROOM_TYPE,
    community,
    $or: [{ public: true }, { members: { $in: [user.id] } }],
  };
  if (Array.isArray(tags)) {
    if (tags.length === 1) {
      filter.$or.push({
        requiresTags: { $in: [tags[0]] },
      });
    } else if (tags.length > 1) {
      filter.$or.push({
        $or: tags.map((tag) => ({ requiresTags: { $in: [tag] } })),
      });
    }
  }
  return filter;
}

export function reducer(state, mergeState) {
  return { ...state, ...mergeState };
}
